<template>
    <footer class="TheFooter">
        <div class="TheFooter-frame u-frameMd">
            <p class="TheFooter-claim">Přes <strong>25 let</strong> s Vámi rosteme a ještě jsme z toho nevyrostli!</p>
            <div class="TheFooter-col">
                <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="60" height="60" version="1.0"
                     style="shape-rendering:geometricPrecision;text-rendering:geometricPrecision;image-rendering:optimizeQuality;fill-rule:evenodd;clip-rule:evenodd"
                     viewBox="0 0 60 59.999"><path d="M30.524.005c16.562.289 29.76 13.956 29.471 30.518-.289 16.563-13.955 29.761-30.519 29.471C12.913 59.705-.283 46.038.005 29.476.295 12.913 13.96-.284 30.524.005zm-.087 4.913c13.851.241 24.886 11.67 24.643 25.52-.241 13.849-11.669 24.885-25.518 24.643-13.85-.241-24.885-11.67-24.644-25.52C5.16 15.712 16.587 4.676 30.437 4.918zm17.715 17.054 1.587-1.267-1.825-.031-1.268 1.273 1.506.025zm-7.915 16.087c1.285.022 1.429-.156 1.459-1.931.029-1.675-.108-1.819-1.393-1.841-1.295-.023-1.437.115-1.467 1.792-.031 1.775.107 1.958 1.401 1.98zm.097-5.549c2.258.04 3.459.805 3.41 3.633-.051 2.879-1.28 3.713-3.538 3.674-2.268-.04-3.468-.915-3.417-3.795.049-2.829 1.277-3.552 3.545-3.512zm-9.239.01-.122 6.996 4.907.085.03-1.687-2.991-.053.094-5.308-1.918-.033zm-4.704 5.298c1.284.022 1.427-.156 1.459-1.933.029-1.675-.11-1.817-1.393-1.841-1.295-.022-1.439.117-1.467 1.792-.032 1.775.105 1.959 1.401 1.982zm.096-5.549c2.258.04 3.459.803 3.41 3.633-.051 2.879-1.28 3.713-3.538 3.674-2.267-.04-3.467-.917-3.416-3.796.05-2.829 1.277-3.55 3.544-3.511zm-6.256 7.059c-1.084-2.338-1.935-3.568-2.254-3.734.338-.306 1.212-1.476 2.227-3.265l2.257.04c-1.066 1.788-1.878 2.888-2.153 3.174.267.236 1.128 1.486 2.201 3.825l-2.278-.04zm-2.327-.041-1.916-.033.121-6.996 1.917.033-.122 6.996zM50.35 22.513l-.029 1.685-3.442-.06-.015.883 2.478.044-.029 1.655-2.478-.042-.019 1.083 3.443.06-.031 1.687-5.358-.094.123-6.995 5.357.094zm-6.677-.117-1.896-.033-.073 4.164a87.554 87.554 0 0 0-2.234-4.204l-2.48-.044-.121 6.996 1.865.033.076-4.287c.808 1.42 1.606 2.869 2.364 4.329l2.378.041.121-6.995zm-8.001-.14-.029 1.686-3.443-.06-.015.884 2.48.042-.031 1.656-2.477-.042-.018 1.083 3.441.06-.03 1.686-5.358-.093.122-6.995 5.358.093zm-11.584-.201-.122 6.995 4.907.085.03-1.688-2.99-.052.093-5.308-1.918-.032zm-1.317-.024-.03 1.686-3.443-.06-.015.884 2.48.042-.031 1.656-2.478-.043-.019 1.083 3.442.06-.029 1.688-5.358-.093.122-6.996 5.359.093zM9.8 28.802l6.171.108.03-1.687-3.101-.054c.627-.853 2.567-3.841 3.148-4.913l.005-.343-5.95-.103-.029 1.685 2.879.051c-.589.984-2.26 3.585-3.146 4.893l-.007.363z" style="fill:#fefefe"/></svg>
                <p>Projekty zahrad a veřejné zeleně. Realizace zahrady na klíč včetně všech stavebních prvků jako jsou
                    koupací
                    jezírka a vodní prvky.</p>
                <a href="https://www.facebook.com/zelenekolo/" target="_blank" rel="noopener">
                    <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="10" height="20" version="1.0"
                         style="shape-rendering:geometricPrecision;text-rendering:geometricPrecision;image-rendering:optimizeQuality;fill-rule:evenodd;clip-rule:evenodd"
                         viewBox="0 0 1.056 2.091"><path d="M.034 1.114h.229v.943c0 .019.015.034.034.034h.388a.034.034 0 0 0 .034-.034v-.939h.264a.033.033 0 0 0 .033-.03l.04-.347a.034.034 0 0 0-.008-.026.033.033 0 0 0-.025-.012H.719V.486C.719.42.754.387.824.387h.199a.034.034 0 0 0 .033-.034V.034A.034.034 0 0 0 1.023 0H.737a.522.522 0 0 0-.343.129.365.365 0 0 0-.12.32v.254h-.24A.034.034 0 0 0 0 .737v.343c0 .019.015.034.034.034z" style="fill:#fff"/></svg>
                </a>
            </div>
            <div class="TheFooter-col">
                <div class="TheFooter-title">Rychlý kontakt</div>
                <p>
                    <strong>Infolinka:</strong> <a href="tel:+420 602 711 602">+420 602 711 602 </a><br>
                    <strong>E-mail:</strong> <a href="mailto:radbych@zelenekolo.cz">radbych@zelenekolo.cz</a>
                </p>
                <div class="TheFooter-title">Otevírací doba</div>
                <p>
                    Pondělí až pátek 7:00 do 15:30 hodin
                </p>
            </div>
            <div class="TheFooter-col">
                <div class="TheFooter-title">Další informace</div>
                <ul class="TheFooter-nav">
                    <li><a href="https://zelenekolo.cz/obchodni-podminky/">Dokumenty ke stažení</a></li>
                    <li><a href="https://zelenekolo.cz/prohlaseni-o-nakladani-s-osobnimi-udaji/">Ochrana osobních
                        údajů</a></li>
                    <li><a href="/cookies/">Zásady cookies (EU)</a></li>
                </ul>
            </div>
            <div class="TheFooter-col">
                <div class="TheFooter-title">Partneři</div>
                <ul class="TheFooter-nav">
                    <li><a target="_blank" rel="noopener" href="https://www.eiwan.cz/">Eiwan atelier</a></li>
                </ul>
                <div class="TheFooter-title">Dotazníky</div>
                <ul class="TheFooter-nav">
                    <li><a href="https://zelenekolo.cz/dotaznik/">Dotazník k Vaší zahradě</a></li>
                </ul>
            </div>
        </div>
        <div class="TheFooter-copy">
            <div class="TheFooter-copyFrame u-frameMd">
                <p><span>Zelené kolo</span></p>

                <p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 123.305 595.281 595.28">
                        <path fill="#ED7339"
                              d="M595.28,420.945c0,164.11-133.529,297.64-297.64,297.64C133.53,718.585,0,585.055,0,420.945 c0-164.11,133.53-297.64,297.64-297.64c63.7,0,124.29,19.91,174.82,56.72l-45.38,49.29c-37.931-25.81-82.511-39.96-129.391-39.96 c-127.7,0-231.59,103.89-231.59,231.59c0,116.47,86.42,213.13,198.51,229.23v-129.94h33.03c54.74,0,99.25-44.521,99.25-99.27 c0-54.74-44.53-99.27-99.25-99.27c-54.74,0-99.29,44.53-99.29,99.27c0,15.79,3.66,31.05,10.69,44.84l-46.46,50.529 c-19.78-27.979-30.26-60.96-30.29-95.34c0-91.2,74.18-165.37,165.35-165.37c91.15,0,165.32,74.17,165.32,165.34 c0,79.84-56.91,146.66-132.29,162.02v67.21c112.109-16.06,198.58-112.76,198.58-229.25c0-22.83-3.5-45.29-10.021-66.91h-0.05 c-5.05-16.69-11.86-33.14-20.95-48.88c-5.67-9.79-12.03-19.05-19.01-27.79l45.01-48.89c11.62,13.53,22.17,28.01,31.19,43.65 c9.38,16.24,16.91,33.05,22.88,50.15l0.189-0.08c0.74,2.1,1.24,4.24,1.931,6.34c0.529,1.59,1.12,3.19,1.62,4.79l-0.141,0.04 C590.61,361.675,595.28,391.035,595.28,420.945z"></path>
                    </svg>
                    <span><a target="_blank" rel="noopener"
                             href="https://www.poski.com/">Webové stránky</a> vytvořilo <strong>Poski.com</strong>. <a
                        target="_blank" rel="noopener" href="http://poski.com/webdesign-tvorba-www-stranek">Tvorba webových stránek</a> na míru.</span>
                </p>
            </div>
        </div>
    </footer>
</template>

<style lang="scss" scoped>
.TheFooter {
    background: #222222;
    color: #666;

    a {
        color: inherit;
        transition: all .25s ease-in-out;
        text-decoration: none;

        &:hover {
            color: #f1b458;
        }
    }

    &-frame {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    &-claim {
        position: relative;
        text-align: center;
        font-size: 1.2em;
        font-weight: 700;
        color: #000;
        padding: 1em;
        margin: -1.8em 0 4em;
        width: 100%;
        background-color: #f1f2f6;
        background-image: linear-gradient(135deg, #f1f2f6 0%, #e6e6e6 74%);
        border: 1px solid #dadada;


        strong {
            color: var(--colorBrandDark);
            font-weight: 900;
        }
    }

    &-col {
        width: 23%;

        p, svg {
            margin-bottom: 10px;
            line-height: 1.8em;
        }

        @media(max-width: 1000px) {
            width: 100%;
            margin-bottom: 2rem;
        }
        @media(max-width: 580px) {
            width: 100%;
            &:last-child {
                margin-bottom: 0;
            }
        }

        svg {
            display: block;
        }
    }

    &-title {
        color: #fff;
        font-weight: 700;
        text-transform: uppercase;
        border-bottom: 2px solid #292929;
        position: relative;
        padding-bottom: .8em;
        margin: 3em 0 1.5em;
        letter-spacing: 3px;
        font-size: 12px;

        &:first-child {
            margin-top: 0;
        }

        &:before {
            content: ' ';
            display: block;
            position: absolute;
            left: 0;
            bottom: 0;
            width: 8px;
            height: 8px;
            transform: translate(0, 58%);
            border-radius: 50%;
            border: 2px solid #292929;
            background: #222;
        }
    }

    &-nav {
        list-style: none;
        margin: 0;
        padding: 0;

        li {
            border-bottom: 1px solid rgba(255, 255, 255, 0.05);
            padding-bottom: .7em;
            margin-bottom: .7em;

            &:last-child {
                border: none;
                padding: 0;
                margin: 0;
            }
        }
    }

    &-copy {
        padding: .2em 0;
        border-top: 1px solid rgba(255, 255, 255, 0.05);
        margin-top: 3em;
    }

    &-copyFrame {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 0;
        @media(max-width: 1000px) {
            text-align: center;
            flex-direction: column;

            p:first-child {
                margin-bottom: 0;
            }
        }

        svg {
            display: inline-block;
            vertical-align: middle;
            margin-right: 10px;
            width: 1.5em;
            height: auto;
        }
    }
}
</style>
<script>
</script>